export default class BadRequestException extends Error {
    public validationErrors: string[];

    constructor(validationErrors: string[]) {
        super();
        this.validationErrors = validationErrors;
    }
}


// WEBPACK FOOTER //
// ./src/Models/Exceptions/BadRequestException.ts